import * as types from './constants';

// Get Regularusers UserGroups
export const getRegularusersGroupsRequest = data => (
  { type: types.GET_REGULARUSERS_GROUPS_REQUEST, payload: data }
);

export const getRegularusersGroupsDone = data => (
  { type: types.GET_REGULARUSERS_GROUPS_DONE, payload: data }
);

export const getRegularusersGroupsFailed = errors => (
  { type: types.GET_REGULARUSERS_GROUPS_FAILED, payload: errors }
);

// Operations
export const regularusersGroupsSetPage = data => (
  { type: types.REGULARUSERS_GROUPS_SET_PAGE, payload: data }
);